import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        productTypes: []
    },

    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getProductTypes(state) {
            return state.productTypes;
        }
    },

    mutations: {
        setProductTypes(state, data) {
            state.productTypes = data;
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loaded(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.productTypes = [];
            state.loadError = err;
        }
    },

    actions: {
        loadProductTypes(context) {
            return new Promise((resolve, reject) => {
                context.commit("loading");

                api.fetchProductTypes({
                    success: function (response) {
                        context.commit("setProductTypes", response.data);
                        resolve();
                    },
                    error: function (e) {
                        context.commit("loadError", api.parseHttpRequestError(e));
                        reject(api.parseHttpRequestError(e));
                    },
                    finally: function () {
                        context.commit("loaded");
                    }
                });
            });
        }
    }
}
